export default __webpack_public_path__ + "static/media/graphs.ab80a12b.svg";